import Button from "../../Components/Buttons/Button"
import Text from "../../Components/Text"
import ScrollWrapper from "../../Components/ScrollWrapper"
import TextInput from "../../Components/Form/TextInput"
import { useState } from "react"
import Order from "../../APIController/Order"

export const CheckoutModal = ({ orderProducts, products, wsID, afterAction, erroraction }) => {
    const [note, setNote] = useState("")
    const { createOrder } = Order()

    const buildOrderDTO = () => ({
        orderType: "PREORDER",
        orderProducts: orderProducts.map(p => ({
            productId: p.productId,
            count: p.count,
            extras: []
        })),
        offers: [],
        paymentType: "UNPAYED",
        comment: note,
        preorderName: localStorage.getItem("user") ? `${JSON.parse(localStorage.getItem("user")).firstName} ${JSON.parse(localStorage.getItem("user")).lastName}` : "",
        preorderEmail: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).email : ""
    })

    const placeOrder = async () => {
        const orderDTO = buildOrderDTO()
        const data = await createOrder(orderDTO, wsID)
        if (data) {
            afterAction()
        } else {
            erroraction(`Restaurantlimit erreicht oder Restaurant geschlossen. Versuche es später erneut.`)
        }
    }

    return (
        <div className="w-full h-full flex flex-col items-center justify-center">
            <Text type="main">Checkout</Text>
            <ScrollWrapper>
                <div className="w-full h-full flex flex-col items-center justify-start p-5">
                    {orderProducts.length === 0 ? (
                        <Text type="itemtext">Keine Produkte im Warenkorb</Text>
                    ) : (
                        <div className="w-full flex flex-col gap-3">
                            {orderProducts.map(op => {
                                const prod = products.find(p => p.id === op.productId)
                                if (!prod) return null
                                return (
                                    <div key={op.productId} className="w-full flex flex-row bg-gray-100 gap-2 p-4 rounded-lg shadow-md">
                                        <div className="flex flex-col w-full gap-2">
                                            <Text type="itemmain">{prod.name}</Text>
                                            <Text type="itemtext">{prod.price} CHF x {op.count}</Text>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                    <TextInput placeholder={"Kommentar"} value={note} action={(e) => setNote(e.target.value)} type={"text"} classNames="w-full mt-5" />
                    <Text type="itemtext" classNames="mt-2">Hinweis: Das Restaurant erhält diesen Kommentar zusammen mit der Bestellung.</Text>
                    <Text type="itemtext" classNames="mt-1">Beachte dass du diese Bestellung vor Ort bezahlen musst.</Text>
                </div>
            </ScrollWrapper>
            {orderProducts.length > 0 && (
                <>
                    <Button text={"Bestellung aufgeben"} onClickAction={() => placeOrder()} classNames="w-full mt-5" />
                    <Text type="itemtext" classNames="mt-2">Durch das Aufgeben der Bestellung stimmst du unseren AGBs zu.</Text>
                </>
            )}

        </div>
    )
}